export const Strikethrough = ({
  id,
  amount,
  strikethroughAmount,
}: {
  id: string;
  amount: string;
  strikethroughAmount: string;
}) => {
  return (
    <div className="tw-flex tw-items-end tw-justify-center tw-gap-1">
      <span
        className="strikethrough tw-text-2xl tw-font-normal tw-opacity-50"
        data-testid={`strikethrough--${id}`}
      >
        {strikethroughAmount}
      </span>
      {amount}
    </div>
  );
};
